import React from 'react';

import { Page } from 'components/page';
import TriageList from 'modules/triage/triage-list';


export default function ViewTriageForTest() {
  return (
    <Page>
      <div style={{ width: '300px', padding: '10px' }}>
        <TriageList activeTab={'triage'} />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./app/routes/triage/view-triage-for-test.js